import { updateObject } from '@/shared/utility';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  token: null,
  error: null,
  loading: false,
  recentlyLoggedOut: false,
  isRegistration: false, // flag we use to determine if the login was a registration
  loginSuccessInProgress: false,
  isTimeoutBlocked: false,
};

const loginSuccess = (state, action) =>
  updateObject(state, {
    token: action.token,
    error: null,
    loading: false,
    isRegistration: action.isRegistration,
    loginSuccessInProgress: true,
  });

const logoutSuccess = state => updateObject(state, { ...initialState, recentlyLoggedOut: true });

const logoutFail = state =>
  updateObject(state, {
    loading: false,
  });

const loginSuccessDone = state =>
  updateObject(state, {
    loginSuccessInProgress: false,
  });

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return loginSuccess(state, action);
    case actionTypes.LOGOUT_SUCCESS:
      return logoutSuccess(state, action);
    case actionTypes.LOGOUT_FAIL:
      return logoutFail(state, action);
    case actionTypes.LOGIN_SUCCESS_DONE:
      return loginSuccessDone(state, action);
    case actionTypes.SET_TIMEOUT_BLOCKED:
      return updateObject(state, { isTimeoutBlocked: action.isTimeoutBlocked });
    default:
      return state;
  }
};

export default authReducer;
